document.addEventListener('DOMContentLoaded', () => {
  const loadMoreBtn = document.getElementById("AjaxinatePagination");
  new Ajaxinate({
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
    method: "click",
    loadingText: loadMoreBtn ? loadMoreBtn.dataset.loadingText : "Loading"
  });
  const url = window.location.href;
  const searchLinksDiv = document.querySelector('.search-links');
  const links = searchLinksDiv.querySelectorAll("a");

  const updateUrlParameter = (url, key, value) => {
    const regex = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    const separator = url.indexOf('?') !== -1 ? '&' : '?';
    if (url.match(regex)) {
      return url.replace(regex, '$1' + key + '=' + value + '$2');
    } else {
      return url + separator + key + '=' + value;
    }
  };

  const getUrlParameter = (url, key) => {
    key = key.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + key + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  };

  if (searchLinksDiv) {
    links.forEach(link => {
      const type = link.dataset.linkType;
      const updatedUrl = updateUrlParameter(url, 'type', type);
      link.href = updateUrlParameter(updatedUrl, 'page', '1'); // Setting page = 1
      if (getUrlParameter(url, 'type') === type) {
        link.classList.add('active');
      }
    });
  }
});